export default "__VITE_ASSET__DNsFfbvU__"